function updateCarouselStyles() {
  const carousel = document.querySelector('.subcollections__wrapper-carousel');
  const container = document.querySelector('.subcollections__container');

  if (!carousel) return;

  const isMobile = window.matchMedia("(pointer: coarse)").matches;

  if (carousel && isMobile) {

    carousel.setAttribute("allow-drag", "");
  }

  //Get carousel width
  const carouselWidth = carousel.offsetWidth;

  //Get computed gap size
  const computedStyle = window.getComputedStyle(carousel);
  const gap = parseFloat(computedStyle.gap) || 0;

  const desktopNumberOfGaps = parseInt(computedStyle.getPropertyValue('--num-desktop')) || 10;
  const tabletNumberOfGaps = parseInt(computedStyle.getPropertyValue('--num-tablet')) || 8;
  const mobileNumberOfGaps = parseInt(computedStyle.getPropertyValue('--num-mobile')) || 3;

  const desktopTotalGapWidth = gap * desktopNumberOfGaps;
  const tabletTotalGapWidth = gap * tabletNumberOfGaps;
  const mobileTotalGapWidth = gap * mobileNumberOfGaps;

  document.documentElement.style.setProperty('--carousel-width', `${carouselWidth}px`);
  document.documentElement.style.setProperty('--tablet-total-gap-width', `${tabletTotalGapWidth}px`);
  document.documentElement.style.setProperty('--desktop-total-gap-width', `${desktopTotalGapWidth}px`);
  document.documentElement.style.setProperty('--mobile-total-gap-width', `${mobileTotalGapWidth}px`);
}

document.addEventListener('DOMContentLoaded', updateCarouselStyles);
window.addEventListener('resize', updateCarouselStyles);
document.addEventListener('shopify:section:load', updateCarouselStyles);
